module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Daisies Are Forever")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "txline"
  }), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter3#ctnvii",
      "id": "cntvii"
    }
  }, [_vm._v("GLOSSARY OF FOREIGN WORDS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4#ctn1",
      "id": "cnt1"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter5#ctn11",
      "id": "cnt11"
    }
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter6#ctn16",
      "id": "cnt16"
    }
  }, [_vm._v("THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#ctn26",
      "id": "cnt26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#ctn37",
      "id": "cnt37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#ctn44",
      "id": "cnt44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#ctn53",
      "id": "cnt53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#ctn62",
      "id": "cnt62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#ctn70",
      "id": "cnt70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#ctn79",
      "id": "cnt79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#ctn87",
      "id": "cnt87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ELEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#ctn96",
      "id": "cnt96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWELVE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#ctn106",
      "id": "cnt106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#ctn116",
      "id": "cnt116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FOURTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#ctn124",
      "id": "cnt124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIFTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#ctn133",
      "id": "cnt133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SIXTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#ctn140",
      "id": "cnt140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SEVENTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#ctn148",
      "id": "cnt148",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EIGHTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#ctn156",
      "id": "cnt156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NINETEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#ctn168",
      "id": "cnt168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#ctn179",
      "id": "cnt179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY-ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#ctn187",
      "id": "cnt187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY-TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#ctn195",
      "id": "cnt195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY-THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#ctn202",
      "id": "cnt202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY-FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#ctn208",
      "id": "cnt208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY-FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#ctn215",
      "id": "cnt215",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY-SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#ctn227",
      "id": "cnt227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY-SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#ctn235",
      "id": "cnt235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY-EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#ctn244",
      "id": "cnt244",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TWENTY-NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#ctn252",
      "id": "cnt252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#ctn261",
      "id": "cnt261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTY-ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#ctn270",
      "id": "cnt270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTY-TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#ctn282",
      "id": "cnt282",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTY-THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#ctn291",
      "id": "cnt291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTY-FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#ctn300",
      "id": "cnt300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTY-FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#ctn309",
      "id": "cnt309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTY-SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40#ctn316",
      "id": "cnt316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTY-SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41#ctn322",
      "id": "cnt322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTY-EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42#ctn330",
      "id": "cnt330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43#ctn335",
      "id": "cnt335",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE STORY BEHIND THE STORY")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44#ctn337",
      "id": "cnt337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("READING GROUP GUIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45#ctn339",
      "id": "cnt339",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter46#ctn343",
      "id": "cnt343",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 72
// module chunks = 0